import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["placeholder", "value"]

import { computed, PropType } from "vue";

export default /*@__PURE__*/_defineComponent({
  __name: 'ReusableTextarea',
  props: {
  modelValue: {
    type: [String, Number, null] as PropType<string | number | null>,
    default: null,
  },
  label: { type: String },
  type: { type: String },
  typeStyle: { type: String, default: "" },
  v: {
    type: Object,
  },
},
  setup(__props) {

const props = __props;
const classes = computed(() => {
  switch (props.typeStyle) {
    case "product":
      return {
        name: "product",
        row: "row",
        label: "col-sm-3 col-form-label",
        input: "col-sm-9",
      };
      break;
    default:
      return { name: "profile", row: "", label: "form-label", input: "" };
      break;
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass('mb-2 ' + classes.value.row)
  }, [
    _createElementVNode("b", {
      for: "address",
      class: _normalizeClass(classes.value.label)
    }, _toDisplayString(__props.label), 3),
    _createElementVNode("div", {
      class: _normalizeClass(classes.value.input)
    }, [
      _createElementVNode("textarea", _mergeProps({
        placeholder: __props.label,
        autocomplete: "off",
        class: "form-control"
      }, _ctx.$attrs, {
        value: __props.modelValue,
        onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:modelValue', $event.target.value)))
      }), null, 16, _hoisted_1),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.v?.$errors, (error) => {
        return (_openBlock(), _createElementBlock("span", {
          class: "text-danger",
          key: error.$uid
        }, _toDisplayString(error.$message), 1))
      }), 128))
    ], 2)
  ], 2))
}
}

})